import { render, staticRenderFns } from "./BoxesComponent.vue?vue&type=template&id=67803f69&scoped=true&"
import script from "./BoxesComponent.vue?vue&type=script&lang=js&"
export * from "./BoxesComponent.vue?vue&type=script&lang=js&"
import style0 from "./BoxesComponent.vue?vue&type=style&index=0&id=67803f69&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67803f69",
  null
  
)

export default component.exports